import React from 'react';
import { motion } from 'framer-motion';
interface BonusCardProps {
  imageUrl: string;
  title: string;
  onClick: () => void;
}
export function BonusCard({
  imageUrl,
  title,
  onClick
}: BonusCardProps) {
  return <motion.div whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className="cursor-pointer group relative overflow-hidden rounded-2xl shadow-2xl" onClick={onClick} data-id="element-1">
      <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 z-10" data-id="element-2" />
      <img src={imageUrl} alt={title} className="w-full h-auto object-cover transform transition-transform duration-500 group-hover:scale-105" data-id="element-3" />
      <div className="absolute bottom-0 left-0 right-0 p-4 translate-y-full group-hover:translate-y-0 transition-transform duration-300 z-20" data-id="element-4">
        <span className="inline-block bg-yellow-400 text-black font-bold px-3 py-1 rounded-full text-sm shadow-md" data-id="element-5">
          ¡GRATIS HOY!
        </span>
      </div>
    </motion.div>;
}